import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  flushIfNeededwozpffp4tkkx as flushIfNeeded,
  ByteWriteChannel$flushAndClose$refn32gpjkb516n as ByteWriteChannel$flushAndClose$ref,
} from './ByteWriteChannel.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { EmptyCoroutineContext_instancegbhtm9svfl3r as EmptyCoroutineContext_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { ByteChannel3cxdguezl3lu7 as ByteChannel } from './ByteChannel.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { startCoroutineCancellable18shtfwdieib as startCoroutineCancellable } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/intrinsics/Cancellable.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
  cancel1xim2hrvjmwpn as cancel,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_NO_CALLBACK() {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return NO_CALLBACK;
}
var NO_CALLBACK;
function *writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? value.length : endIndex;
  _this__u8e3s4.r4j().q4g(value, startIndex, endIndex);
  yield* flushIfNeeded(_this__u8e3s4, $completion);
  return Unit_instance;
}
var WriterJobClass;
function WriterJob() {
  if (WriterJobClass === VOID) {
    class $ {
      constructor(channel, job) {
        this.a4l_1 = channel;
        this.b4l_1 = job;
      }
      h12() {
        return this.b4l_1;
      }
    }
    initMetadataForClass($, 'WriterJob');
    WriterJobClass = $;
  }
  return WriterJobClass;
}
function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
  autoFlush = autoFlush === VOID ? false : autoFlush;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return writer_0(_this__u8e3s4, coroutineContext, new (ByteChannel())(), block);
}
var WriterScopeClass;
function WriterScope() {
  if (WriterScopeClass === VOID) {
    class $ {
      constructor(channel, coroutineContext) {
        this.k4l_1 = channel;
        this.l4l_1 = coroutineContext;
      }
      bw() {
        return this.l4l_1;
      }
    }
    initMetadataForClass($, 'WriterScope');
    WriterScopeClass = $;
  }
  return WriterScopeClass;
}
function invokeOnCompletion(_this__u8e3s4, block) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return _this__u8e3s4.h12().ex(block);
}
function close(_this__u8e3s4, cause) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  if (cause == null) {
    fireAndForget(ByteWriteChannel$flushAndClose$ref(_this__u8e3s4));
  } else {
    _this__u8e3s4.o4k(cause);
  }
}
function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_instance : coroutineContext;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  // Inline function 'kotlin.apply' call
  var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda(block, channel));
  this_0.ex((it) => {
    var tmp;
    if (!(it == null) && !channel.x4j()) {
      channel.o4k(it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
  var job = this_0;
  return new (WriterJob())(channel, job);
}
function fireAndForget(_this__u8e3s4) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
}
function *writeByte(_this__u8e3s4, value, $completion) {
  _this__u8e3s4.r4j().a4h(value);
  yield* flushIfNeeded(_this__u8e3s4, $completion);
  return Unit_instance;
}
var NO_CALLBACK$1Class;
function NO_CALLBACK$1() {
  if (NO_CALLBACK$1Class === VOID) {
    class $ {
      constructor() {
        this.m4l_1 = EmptyCoroutineContext_instance;
      }
      pc() {
        return this.m4l_1;
      }
      qc(result) {
        return Unit_instance;
      }
      rc(result) {
        return this.qc(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    NO_CALLBACK$1Class = $;
  }
  return NO_CALLBACK$1Class;
}
function writer$slambda($block, $channel) {
  return constructCallableReference(function *($this$launch, $completion) {
    var nested = Job(get_job($this$launch.bw()));
    var tmp;
    try {
      yield* $block(new (WriterScope())($channel, $this$launch.bw().pm(nested)), $completion);
      nested.t12();
      var tmp_0;
      if (get_job($this$launch.bw()).yw()) {
        $channel.o4k(get_job($this$launch.bw()).bx());
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var cause = $p;
        cancel(nested, 'Exception thrown while writing to channel', cause);
        $channel.o4k(cause);
        tmp_1 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    finally {
      yield* nested.ix($completion);
      // Inline function 'kotlin.runCatching' call
      var tmp_2;
      try {
        yield* $channel.n4k($completion);
        // Inline function 'kotlin.Companion.success' call
        tmp_2 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p_0) {
        var tmp_3;
        if ($p_0 instanceof Error) {
          var e = $p_0;
          // Inline function 'kotlin.Companion.failure' call
          tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p_0;
        }
        tmp_2 = tmp_3;
      }
    }
    return Unit_instance;
  }, 1);
}
var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
  if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
    properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
    NO_CALLBACK = new (NO_CALLBACK$1())();
  }
}
//region block: exports
export {
  writeByte as writeByte1wjyp0flxjqrr,
  writeFully as writeFullyuc6cd2hh6ex3,
  close as close3semq7pafb42g,
  invokeOnCompletion as invokeOnCompletion1ziuxzoag0iwj,
  writer as writer1eia5its2a1fh,
};
//endregion

//# sourceMappingURL=ByteWriteChannelOperations.mjs.map
